import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import GetRecapDocument from "src/api/graphql/__generated__/documents/GetRecapDocument";
import Loading from "src/components/Loading";
import useCelebration from "src/hooks/useCelebration";
import { useInsideModal } from "src/modals";
import InternalModal from "src/modals/configs/InternalModal";
import General404 from "src/screens/(error)/General404";
import RecapContent from "./components/RecapContent";
import { useRecapModalDimensions } from "./RecapModalSkeleton";

const RecapModal = () => {
	const style = useRecapModalDimensions();
	const { props, closeSelf } = useInsideModal<InternalModal["Recap"]>();
	const { data, loading } = useQuery(GetRecapDocument, {
		variables: {
			input: {
				recapId: props.recapId,
			},
		},
		skip: !!props.recap,
	});
	const recap = props.recap ?? data?.getRecap;
	const { launchConfettiCannon } = useCelebration();
	useEffect(() => {
		const timeout = setTimeout(() => {
			launchConfettiCannon("Rain");
		}, 1000);
		return () => clearTimeout(timeout);
	}, [launchConfettiCannon]);

	if (loading) return <Loading variant="Screen" />;
	if (!recap) return <General404 />;
	return <RecapContent recap={recap} style={style} onClose={closeSelf} />;
};
export default RecapModal;
